// extracted by mini-css-extract-plugin
module.exports = {"video":"media_video__47xma","video__wrapper":"media_video__wrapper__x2jGs","video__iframe":"media_video__iframe__x__dZ"};